import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//base
import { BaseDropdownComponent }                from '../../baseclasses/BaseDropdown.component';

@Component({
  selector: 'my-salesoffice-dropdown',
  templateUrl: './SalesOfficeDropdown.component.html',
  providers: [{provide: BaseDropdownComponent, useExisting: forwardRef(() => SalesOfficeDropdownComponent)}]
})
export class SalesOfficeDropdownComponent extends BaseDropdownComponent {

    
    @Input() public salesOfficeFilter: filters.SalesOfficeFilter;
    @Input() public includeInactive: boolean;
    @Input() public showAsDeliveryPlant: boolean;
    
    public salesOffices: ent.SalesOffice[] = [];

    constructor(private domainDataService: serv.DomainDataService) 
    {
        super();
        this.salesOfficeFilter = {IncludeInactive: this.includeInactive};
    }


    ngOnInit(): void {
    }

    public load(){

        var results = this.domainDataService.getSalesOfficesFromCache(this.salesOfficeFilter);
        this.selectItems.push({label:"", value:Constants._NONE});
        results.forEach(y=> this.selectItems.push({label:y.FullName, value:y.ID}));
        results.forEach(y=> this.salesOffices.push(y));
        this.value = this.selectedID;
        this.loadDone.emit(null);
        
    }
    
}